export default angular.module("articles_adapter_module", []);